module.exports = __webpack_public_path__ + "static/media/ensto.3a2a9fac.svg";